module.exports = __webpack_public_path__ + "static/media/carret-up.03a99024.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/svg/carret-up.svg
// module id = 6125
// module chunks = 0